import { render, staticRenderFns } from "./IllegalOrder.vue?vue&type=template&id=4260b17e&scoped=true"
import script from "./IllegalOrder.vue?vue&type=script&lang=js"
export * from "./IllegalOrder.vue?vue&type=script&lang=js"
import style0 from "./IllegalOrder.vue?vue&type=style&index=0&id=4260b17e&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4260b17e",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/root/.jenkins/workspace/web-ug-admin-dev/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('4260b17e')) {
      api.createRecord('4260b17e', component.options)
    } else {
      api.reload('4260b17e', component.options)
    }
    module.hot.accept("./IllegalOrder.vue?vue&type=template&id=4260b17e&scoped=true", function () {
      api.rerender('4260b17e', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/orderManagement/commissionBaseDeductionSetting/components/IllegalOrder.vue"
export default component.exports